import PropTypes from 'prop-types';

import { Abstrap } from '..';

const propTypes = {
    ...Abstrap.propTypes,
    align: PropTypes.oneOf(['left', 'right']),
    vcenter: PropTypes.bool,
    hcenter: PropTypes.bool,
    noCol: PropTypes.bool,
    spaceBetween: PropTypes.bool,
    noWrap: PropTypes.bool,
    column: PropTypes.bool,
    vbottom: PropTypes.bool,
};

const defaultProps = {
    ...Abstrap.defaultProps,
    componentClass: 'div',
    align: 'left',
    vcenter: false,
    vbottom: false,
    hcenter: false,
    noCol: false,
    spaceBetween: false,
    noWrap: false,
    column: false,
};

class Row extends Abstrap {

    getClassNameSchema() {
        const {
            className,
            vcenter,
            vbottom,
            hcenter,
            align,
            noCol,
            spaceBetween,
            noWrap,
            column,
        } = this.props;
        return [
            'c-grid__row',
            noCol ? 'c-grid__row--no-col' : false,
            noWrap ? 'c-grid__row--no-wrap' : false,
            vcenter ? 'c-grid__row--align-vcenter' : false,
            vbottom ? 'c-grid__row--align-vbottom' : false,
            hcenter ? 'c-grid__row--align-hcenter' : false,
            spaceBetween ? 'c-grid__row--space-between' : false,
            column ? 'c-grid__row--column' : false,
            align === 'right' ? 'c-grid__row--align-right' : false,
            className,
        ];
    }

}

Row.propTypes = propTypes;

Row.defaultProps = defaultProps;

export default Row;
